import { ClientDetailsRow } from "@components/organizationView/clients/views/clientViewConfig";
import { ClientsCloseOverviewRow } from "./clientsCloseOverviewViewConfig";

/**
 * Converts a workspace-level ClientsCloseOverviewRow into the ClientDetailsRow
 * shape expected by ClientActionsDropdown and ClientActionsProvider.
 *
 * Fields not available on the closes overview row are set to safe defaults
 * (empty arrays, nulls, false). The dropdown guards actions behind permission
 * checks and billing-ownership flags that are present on the row, so the
 * result is functionally correct for the actions that matter.
 */
export function closeOverviewRowToClientRow(
    row: ClientsCloseOverviewRow,
): ClientDetailsRow {
    // Strip the "workspace:" prefix that the overview API adds
    const workspaceId = row.id.replace("workspace:", "");

    return {
        id: workspaceId,
        name: row.name,
        note: row.note ?? null,
        plan: row.plan ?? null,
        bookkeepingStartDate: row.bookkeepingStartDate ?? "",
        isFirmWorkspace: row.isFirmWorkspace ?? false,
        isDemo: false,
        services: row.services ?? null,
        entities: [],
        isOrganizationBillingOwner: row.isOrganizationBillingOwner ?? false,
        hasUsersToTransferBillingTo: row.hasUsersToTransferBillingTo ?? false,
        members: row.members ?? [],
        primaryAdminUserId: null,
        pendingTransferRequests: [],
        orgBillingTransferRequest: row.orgBillingTransferRequest ?? null,
        type: "workspace",
        closeStatus: null,
        closeDate: null,
        dueDate: null,
        priority: null,
        legalType: null,
        closeStage: null,
        closeStageUpdatedAt: null,
    };
}
